<template>
  <div>
    <div class="heading">
      <div>Discount Code Details</div>

      <div class="button cta small success" @click="exportDC()">export</div>
    </div>

    <div :class="['d-flex', showRecords ? 'mobile-right-panel' : '']">
      <div class="details-box">
        <div class="row row-padding">
          <div class="data-field">
            <div class="label">Code</div>
            <input type="text" :class="{'input':true, 'has-error':!!error.code}"
              v-model="code" disabled />
            <span class="error-msg">{{ error.code }}</span>
          </div>
        </div>
        <div class="row row-padding">
          <div class="data-field">
            <div class="label">Description</div>
            <textarea v-model="desc"></textarea>
          </div>
        </div>
        <div class="row row-padding">
          <div class="column small-6 padding-R">
            <div class="data-field">
              <div class="label">Type</div>
              <select v-model="type" :disabled="view.list.length > 0">
                <option value="$">$</option>
                <option value="%">%</option>
              </select>
            </div>
          </div>
          <div class="column small-6 padding-L">
            <div class="data-field">
              <div class="label">Amount</div>
              <input type="text" v-model="amount" :disabled="view.list.length > 0"
               :class="{'input':true, 'has-error':!!error.amount}" />
              <span class="error-msg">{{ error.amount }}</span>
            </div>
          </div>
        </div>
        <div class="row row-padding">
          <div class="column small-12 end">
            <div class="data-field input-date">
              <div class="label">Start Date</div>
              <div class="row">
                <div class="column small-5 padding-R">
                  <datepicker class="datepicker inline" :format="calendarFormat"
                    v-model="startDate" :disabled="startDateDisabled"
                    v-on:input="changeDate('startDate')"
                    :input-class="{'datepicker-empty':error.startDate}"
                  ></datepicker>
                  <span class="error-msg">{{ error.startDate || error.startHr || error.startMin }}</span>
                </div>
                <div class="column small-3 padding-L">
                  <select v-model="startHr"
                    :class="{'has-error':!!error.startHr}">
                    <option value="" disabled selected>Hour</option>
                    <option v-for="x in 24" :value="leadingZero(x - 1)" :key="x">{{ leadingZero(x - 1) }}</option>
                  </select>
                </div>
                <div class="column small-1 text-center"><span class="time">:</span></div>
                <div class="column small-3 padding-R">
                  <select v-model="startMin"
                    :class="{'has-error':!!error.startMin}">
                    <option value="" disabled selected>Minute</option>
                    <option v-for="x in 12" :value="leadingZero((x - 1) * 5)" :key="x">{{ leadingZero((x - 1) * 5) }}</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row row-padding">
          <div class="column small-12 end">
            <div class="data-field input-date">
              <div class="label">End Date</div>
              <div class="row">
                <div class="column small-5 padding-R">
                  <datepicker class="datepicker inline" :format="calendarFormat"
                    v-model="endDate" :disabled="endDateDisabled"
                    v-on:input="changeDate('endDate')"
                    :input-class="{'datepicker-empty':error.endDate}"
                  ></datepicker>
                  <span class="error-msg">{{ error.endDate || error.endHr || error.endMin }}</span>
                </div>
                <div class="column small-3 padding-L">
                  <select v-model="endHr"
                    :class="{'has-error':!!error.endHr}">
                    <option value="" disabled selected>Hour</option>
                    <option v-for="x in 24" :value="leadingZero(x - 1)" :key="x">{{ leadingZero(x - 1) }}</option>
                  </select>
                </div>
                <div class="column small-1 text-center"><span class="time">:</span></div>
                <div class="column small-3 padding-R">
                  <select v-model="endMin"
                    :class="{'has-error':!!error.endMin}">
                    <option value="" disabled selected>Minute</option>
                    <option v-for="x in 12" :value="leadingZero((x - 1) * 5)" :key="x">{{ leadingZero((x - 1) * 5) }}</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row row-padding">
          <div class="column small-4 padding-R">
            <div class="data-field">
              <div class="label">Valid Only for New Users</div>
              <select v-model="newUsers">
                <option value="1">Yes</option>
                <option value="0">No</option>
              </select>
            </div>
          </div>
          <div class="column small-4 padding-R padding-L">
            <div class="data-field">
              <div class="label">Redeemable once per user</div>
              <select v-model="reedemOnce">
                <option value="1">Yes</option>
                <option value="0">No</option>
              </select>
            </div>
          </div>
          <div class="column small-4 padding-L">
            <div class="data-field">
              <div class="label">Number of Codes to Redeem</div>
              <input type="text" v-model="maxUse" :class="['input', {'has-error':!!error.maxUse}]" />
              <span class="error-msg">{{ error.maxUse }}</span>
            </div>
          </div>
        </div>

        <div class="row row-padding">
          <!-- <div class="column small-6 padding-R">
            <div class="data-field">
              <div class="label">Enabled</div>
              <select v-model="enabled">
                <option :value="true">Enabled</option>
                <option :value="false">Disabled</option>
              </select>
            </div>
          </div> -->
          <div class="column small-6 padding-R">
            <label class="check-field">
              <input type="checkbox" v-model="isWidget" />
              Enable on Widget
            </label>
          </div>
          <div class="column small-6 padding-R">
            <label class="check-field">
              <input type="checkbox" v-model="isApp" />
              Enable on App
            </label>
          </div>
        </div>

        <div class="row row-padding">
          <div class="column">
            <div class="button cta success block" @click="update">Update</div>
          </div>
        </div>
      </div>

      <div class="usage-box">
        <rsvp-list ref="rsvpList" />
      </div>
    </div>

    <div class="toggle-mobile" @click="showRecords = !showRecords">
      <span v-if="!showRecords">Show Records <i class="fa fa-chevron-up"></i></span>
      <span v-else>Hide Records <i class="fa fa-chevron-down"></i></span>  
    </div>
  </div>
</template>

<script>
import moment from 'moment-timezone'
import datepicker from 'vuejs-datepicker'
import RsvpList from './RsvpList'
import CsvExport from 'csvexport'

const exporter = CsvExport.create({
  filename: 'discount-code-export.csv',
  columns: [ 'RSVP ID', 'Created', 'Discount Amount' ]
})

export default {
  name: 'discount-code-view',
  components: { datepicker, RsvpList },
  data () {
    return {
      code: '',
      desc: '',
      type: '',
      amount: '',
      created: '',
      startDate: '',
      startHr: '',
      startMin: '',
      endDate: '',
      endHr: '',
      endMin: '',
      // enabled: '',
      maxUse: '',
      newUsers: '',
      reedemOnce: '',
      isWidget: false,
      isApp: false,
      error: {
        code: '',
        amount: '',
        startDate: '',
        startHr: '',
        startMin: '',
        endDate: '',
        endHr: '',
        endMin: '',
        maxUse: ''
      },
      today: moment(),
      exportLoading: false,
      showRecords: false
    }
  },
  computed: {
    id () { return this.$route.params.id },
    discountCodes () { return this.$store.state.discountCodes },
    view () { return this.discountCodes.view },
    startDateDisabled () {
      if (this.today.format('MM') === '01') {
        return {
          to: new Date(
            this.today.subtract(1, 'months').format('YYYY'),
            this.today.format('MM'),
            this.today.format('DD')
          )
        }
      }

      return {
        to: new Date(
          this.today.format('YYYY'),
          this.today.subtract(1, 'months').format('MM'),
          this.today.format('DD')
        )
      }
    },
    endDateDisabled () {
      let date = this.startDate ? moment(this.startDate).add(1, 'days') : moment()
      if (date.format('MM') === '01') {
        return {
          to: new Date(
            date.subtract(1, 'months').format('YYYY'),
            date.format('MM'),
            date.format('DD')
          )
        }
      }

      return {
        to: new Date(
          date.format('YYYY'),
          date.subtract(1, 'months').format('MM'),
          date.format('DD')
        )
      }
    }
  },
  methods: {
    getDetails () {
      let self = this

      this.$store.commit('global/setLoaderData', { show: true, message: '' })
      self.$sdk.get(`/discountcode/${self.id}`, {
        token: self.$store.state.session.sessionToken,
      }, res => {
        this.$store.commit('global/setLoaderData', { show: false, message: '' })
        if (res.error) {
          self.$store.commit('global/setAlertData', {
            show: true,
            message: res.error.message
          })
          self.$router.push('/discount-codes')
          return
        }

        self.code = res.code
        self.desc = res.description
        self.type = res.type
        self.amount = res.amount
        self.created = moment(res.created, 'X').format('MM/DD/YYYY hh:mmA')
        let startDate = moment(res.start, 'X')
        self.startDate = startDate.format('MM/DD/YYYY')
        self.startHr = startDate.format('HH')
        self.startMin = startDate.format('mm')
        let endDate = moment(res.end, 'X')
        self.endDate = endDate.format('MM/DD/YYYY')
        self.endHr = endDate.format('HH')
        self.endMin = endDate.format('mm')
        // self.enabled = res.isWidget
        self.maxUse = res.maxUse
        self.newUsers = res.newUsersOnly ? '1' : '0'
        self.reedemOnce = res.oncePerUser ? '1' : '0'
        self.isWidget = res.isWidget
        self.isApp = res.isApp
      })
    },
    calendarFormat (date) { return moment(date).format('MM/DD/YYYY') },
    changeDate (field) {
      this[field] = moment(this[field]).format('MM/DD/YYYY')
    },
    leadingZero (x) { return x < 10 ? '0' + x : x },
    update () {
      let self = this

      let start = moment(`${self.startDate} ${self.startHr}:${self.startMin}`, 'MM/DD/YYYY HH:mm').format('X')
      let end = moment(`${self.endDate} ${self.endHr}:${self.endMin}`, 'MM/DD/YYYY HH:mm').format('X')
      self.$store.commit('global/setLoaderData', { show: true, message: '' })
      let data = {
        token: self.$store.state.session.sessionToken,
        start: start,
        end: end,
        isWidget: self.isWidget,
        isApp: self.isApp,
        description: self.desc,
        maxUse: self.maxUse,
        oncePerUser: self.reedemOnce == '1',
        newUsersOnly: self.newUsers == '1'
      }
      if (self.view.list.length == 0) {
        data.amount = self.amount
        data.type = self.type
      }
      self.$sdk.post(`/discountcode/${self.id}`, data, res => {
        self.$store.commit('global/setLoaderData', { show: false, message: '' })
        if (res.error) {
          self.$store.commit('global/setAlertData', {
            show: true,
            message: res.error.message
          })
          return
        }
        self.$store.commit('global/setAlertData', {
          show: true,
          message: 'Success! Discount code was updated!'
        })
      })
    },
    exportDC () {
      let self = this
      if (self.exportLoading) return
      self.exportLoading = true

      self.$sdk.get(`/discountcode/${self.id}/usage`, {
        token: self.$store.state.session.sessionToken,
      }, res => {
        self.exportLoading = false

        if (res.error) {
          self.$store.commit('global/setAlertData', {
            show: true,
            message: res.error.message
          })
          return
        }
        if (!res.list.length) {
          self.$store.commit('global/setAlertData', {
            show: true,
            message: `<b>${self.code}</b> Empty data.`
          })
          return
        }

        let list = []
        res.list.forEach(data => {
          list.push({
            'RSVP ID': data.rsvpId,
            'Created': moment(data.created, 'X').format('MM/DD/YYYY hh:mmA'),
            'Discount Amount': `$${data.discountAmount.toFixed(2)}`
          })
        })
        exporter.downloadCsv(list)
      })
    }
  },
  mounted () {
    this.getDetails()
    // if (this.$refs.rsvpList) {
    //   this.$refs.rsvpList.getList()
    // }
  }
}
</script>

<style lang="scss" scoped>
.heading{
  margin-left: 50px;
  padding: 0 10px;
  height: 50px;
  background: #fff;
  border-bottom: 1px solid #ddd;
  line-height: 50px;
  color: #3F2975;
  font-size: 21px;
  font-weight: 600;
  text-transform: uppercase;
  display: flex;
  justify-content: space-between!important;
  align-items: center!important;
}

.details-box{
  padding: 10px;
  width: 50%;
  max-width: 700px;
  height: calc(100vh - 50px);
  border-right: 1px solid #ccc;
  overflow: auto;
}
.data-field{
  position: relative;
  margin-bottom: 10px;
  .label{
    color: #888;
    font-weight: 600;
    font-size: 12px;
    line-height: 130%;
    margin-bottom: 1px;

    &.has-error{ color: #f20d0d; }
    &.underline{
      padding-bottom: 3px;
      margin-bottom: 10px;
      border-bottom: 1px solid #ccc;
    }
    .secondary{
      color: #5390dc;
      display: inline-block;
      margin-left:3px;
    }
  }
  .input{
    margin: 1px 0 0;
    color: #333;
    line-height: inherit;
    transition: all .35s ease;

    &.has-error{ border-color: #f20d0d; }
    &:disabled{ background: #eee; }
  }
  textarea{
    border: 1px solid #ddd;
    width: 100%;
    height: 100px;
    resize: none;
    padding: 10px;
    font-size: 13px;
    color: #555;
    outline: none;
    margin-top: 5px;

    &.has-error{ border-color: #f20d0d; }
  }
  .error-msg{
    font-size: 11px;
    line-height: 1.6;
    color: #f20d0d;
    font-style: italic;
    display: block;
  }
}
select{
  margin-top: 1px;
  border: 1px solid #aaa;
  padding: 10px;
  color: #333;
  height: 45px;
  position: relative;
  font-size:14px;
  outline: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  background-image: url('/assets/img/dropdown-arrow.png');
  background-repeat: no-repeat;
  background-position: right 50%;
  transition: all .35s ease;

  &.has-error{ border-color: #f20d0d; }
  &:disabled{ background-color: #eee; }
}
.check-field{
  font-size: 15px;
  margin-bottom: 10px;
  display: inline-block;
  input {
    width: auto;
    display: inline-block;
    margin-right: 3px;
    vertical-align: -1px;
  }
}

.row{ max-width: 100%; }
.row-padding{ padding: 5px 15px; }
.padding-L{ padding-left: 10px; }
.padding-R{ padding-right: 10px; }
.margin-B{ margin-bottom: 20px; }
.text-center{ text-align: center; }

.usage-box{
  width:100%;
  background:#fff;
}

.toggle-mobile {
  display: none;
}

@media only screen and (max-width: 430px) {
  .heading {
    font-size: 16px;
  }

  .data-field {
    .label {
      font-size: 10px;
    }
  }

  .d-flex {
    .details-box {
      width: 100%;
      height: 110vh;
    }

    .usage-box {
      top: 100%;
      position: fixed;
      transition: all 0.3s ease;
    }
    &.mobile-right-panel {

      .details-box {
        display: none;
      }
      
      .usage-box {
        top: 50px;
      }
    }
  }

  .toggle-mobile {
    display: block;
    color: #fff;
    background-color: #333;
    cursor: pointer;
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    text-align: center;
    padding: 8px 0;
    height: 45px;
    -webkit-transition: top .25s;
    transition: top .25s;
    z-index: 9;
    text-transform: uppercase;
    font-weight: 900;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/DiscountCodes/Details.vue